// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const resetReportIsScrollable = () => ({
    type: actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE
});

export const toggleReportIsScrollable = () => ({
    type: actions.TOGGLE_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/report-is-scrollable.js